import { useEffect, useState } from "react";
import "./AdminPage.scss";
import { Route, Switch, Redirect, useLocation } from "react-router";
import AdminCompanyDisclaimerList from "./AdminCompanyDisclaimersPage/AdminCompanyDisclaimerList";
import { PAGES, ROUTE_PATHS } from "../../InternalApiApp";
import RolePermissionsList from "./RolePermissions/RolePermissionsList";
import UserManagement from "./UserManagement/UserManagement";
import SystemUserPage from "./UserManagement/SystemUserPage";
import TickerList from "./Ticker/TickerList";
import TickerPage from "./Ticker/TickerPage";
import TemplateList from "./Templates/TemplateList";
import TemplateMgmt from "./Templates/TemplateMgmt";
import SectorList from "./Sectors/SectorList";
import SectorPage from "./Sectors/SectorPage";
import EmailTemplates from "./System/EmailTemplates";
import ExternalAccessList from "./ExternalAccess/ExternalAccessList";
import ExternalAccessCompanyPage from "./ExternalAccess/ExternalAccessCompanyPage";
import ExternalAccessUsersList from "./ExternalAccess/ExternalAccessUsersList";
import ExternalAccessCommentaryTracker from "./ExternalAccess/ExternalAccessCommentaryTracker";
import EmailTemplatePage from "./System/EmailTemplatePage";
import ModelsList from "./ModelPortfolio/ModelsList";
import ModelPortfolioPage from "./ModelPortfolio/ModelPortfolioPage";
import NoAccess from "../../NoAccess";
import { hasFeature, pluralise, useStorage } from "../../Utils/Utils";
import SchemesList from './SchemesAndFunds/SchemesList'
import SchemePage from './SchemesAndFunds/SchemePage'
import FundsList from './SchemesAndFunds/FundsList'
import FundPage from './SchemesAndFunds/FundPage'
import OffersList from './SchemesAndFunds/OffersList'
import OfferPage from './SchemesAndFunds/OfferPage'
import StyleGuide from "./BrandSettings/StyleGuide";
import SubBrandPage from "./BrandSettings/SubBrandPage";
import SubBrandsList from "./BrandSettings/SubBrandsList";
import AssetClassesList from "./AssetClassManagement/AssetClassesList";
import AssetClassPage from './AssetClassManagement/AssetClassPage'
import PortfolioManagementList from "./PortfolioManagement/PortfolioManagementList";
import PortfolioManagerPage from "./PortfolioManagement/PortfolioManagerPage";
import AnalyticsConfigEditor from "./AnalyticsConfig/AnalyticsConfigEditor";

export const ADMIN_SUB_PAGES = { TICKERS: "tickers", DISCLAIMERS: "disclaimers", MAILING_LIST: "mailing-list", REVIEW_LIST: "review-list" };
export const ADMIN_SUB_PATHS = { [ADMIN_SUB_PAGES.DISCLAIMERS]: "/disclaimers", [ADMIN_SUB_PAGES.MAILING_LIST]: "/mailing-list", [ADMIN_SUB_PAGES.REVIEW_LIST]: "/review-list" };

const AdminPage = ({ me, organisation }) => {
	const storage = useStorage()
	const location = useLocation();

	const [portfolioHierarchy, setPortfolioHierarchy] = useState([]);

	useEffect(() => {
		if (me && me.perms && me.perms.includes("PORTFOLIO_MANAGEMENT")) {
			storage.getOrFetch("funds/portfolio/groupings/hierarchy").then((hierarchy) => {
				hierarchy = hierarchy.filter((item) => item.displaysInHierarchy).sort((a, b) => a.hierarchyOrder - b.hierarchyOrder).map((item) => item.groupingName);
				setPortfolioHierarchy(hierarchy)
			})
		}
	}, []);

	if (!me || !me.perms) {
		return <NoAccess />
	}

	const portfolioGroupingListRoutes = portfolioHierarchy.map((groupingName) => {
		return (
			<Route
				key={groupingName + "-list"}
				exact
				path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/${pluralise(groupingName).toLowerCase()}`}
				render={() => hasFeature("PORTFOLIO_MANAGEMENT", <PortfolioManagementList grouping={groupingName} me={me} />, me)}
			/>
		)
	})

	const portfolioGroupingDetailRoutes = portfolioHierarchy.map((groupingName) => {
		return (
			// <React.Fragment key={groupingName}>
			<Route key={groupingName + "-detail"} path={ROUTE_PATHS[PAGES.ADMIN] + `/portfolio-management/${pluralise(groupingName).toLowerCase()}/:id`} render={() => hasFeature("PORTFOLIO_MANAGEMENT", <PortfolioManagerPage />, me)} />
			// </React.Fragment>
		)
	})

	return (
		<>
			<Switch>
				<Route path={ROUTE_PATHS[PAGES.ADMIN] + "/fund-management/funds/:fundId"} component={hasFeature("FUNDS", FundPage, me)} />
				<Route path={ROUTE_PATHS[PAGES.ADMIN] + "/fund-management/offers/:offerId"} component={hasFeature("FUNDS", OfferPage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/fund-management"} component={hasFeature("FUNDS", SchemesList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/fund-management/schemes"} component={hasFeature("FUNDS", SchemesList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/fund-management/funds"} component={hasFeature("FUNDS", FundsList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/fund-management/offers"} component={hasFeature("FUNDS", OffersList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/fund-management/schemes/:schemeId"} component={hasFeature("FUNDS", SchemePage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/tickers"} component={hasFeature("TICKERS", TickerList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/tickers/:ticker"} component={hasFeature("TICKERS", TickerPage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/model-portfolio"} component={hasFeature("MODEL_PORTFOLIOS", ModelsList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/model-portfolio/:modelName/:modelId"} component={hasFeature("MODEL_PORTFOLIOS", ModelPortfolioPage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/asset-class"} component={hasFeature("ASSET_CLASS_MGT", AssetClassesList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/asset-class/:asetClassId"} component={hasFeature("ASSET_CLASS_MGT", AssetClassPage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/sectors"} component={hasFeature("SECTORS", SectorList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/sectors/sector"} component={hasFeature("SECTORS", SectorPage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + ADMIN_SUB_PATHS[ADMIN_SUB_PAGES.DISCLAIMERS]} component={hasFeature("DISCLAIMER", AdminCompanyDisclaimerList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/user-management"} component={() => hasFeature("USER_MANAGEMENT", <UserManagement me={me} />, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/user-management/:userId"} component={hasFeature("USER_MANAGEMENT", SystemUserPage, me)} />
				{/* <Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/company-management"} component={hasFeature("COMPANY_MANAGEMENT", CompanyMgmt, me)} /> */}

				{/* <Portfolio Management List Pages /> */}
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/portfolio-management/platforms"} render={() => hasFeature("PORTFOLIO_MANAGEMENT", <PortfolioManagementList platform me={me} />, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/portfolio-management/products"} render={() => hasFeature("PORTFOLIO_MANAGEMENT", <PortfolioManagementList product me={me} />, me)} />
				{portfolioGroupingListRoutes}
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/portfolio-management/portfolios"} render={() => hasFeature("PORTFOLIO_MANAGEMENT", <PortfolioManagementList me={me} />, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/portfolio-management"} render={() => <Redirect to="/admin/portfolio-management/portfolios" />} />

				{/* <Portfolio Management Detail Pages /> */}
				<Route path={ROUTE_PATHS[PAGES.ADMIN] + "/portfolio-management/platforms/:schemeId"} render={() => hasFeature("PORTFOLIO_MANAGEMENT", <SchemePage portfolio />, me)} />
				<Route path={ROUTE_PATHS[PAGES.ADMIN] + "/portfolio-management/products/:offerId"} render={() => hasFeature("PORTFOLIO_MANAGEMENT", <OfferPage portfolio />, me)} />
				{portfolioGroupingDetailRoutes}
				<Route path={ROUTE_PATHS[PAGES.ADMIN] + "/portfolio-management/portfolios/:fundId"} render={() => hasFeature("PORTFOLIO_MANAGEMENT", <FundPage me={me} portfolio />, me)} />

				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/external-access/companies"} component={hasFeature("EXTERNAL_ACCESS_MANAGEMENT", ExternalAccessList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/external-access/users"} component={hasFeature("EXTERNAL_ACCESS_MANAGEMENT", ExternalAccessUsersList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/external-access/commentary-tracker"} component={hasFeature("EXTERNAL_ACCESS_MANAGEMENT", ExternalAccessCommentaryTracker, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/external-access"} render={() => <Redirect to="/admin/external-access/companies" />} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/external-access/companies/:externalAccessId"} component={hasFeature("EXTERNAL_ACCESS_MANAGEMENT", ExternalAccessCompanyPage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/company-email-templates"} component={hasFeature("COMPANY_MANAGEMENT", EmailTemplates, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/company-email-templates/:emailTemplateId"} component={hasFeature("COMPANY_MANAGEMENT", EmailTemplatePage, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/role-permissions"} component={hasFeature("ROLES", RolePermissionsList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/templates/:template"} component={() => hasFeature("TEMPLATES", <TemplateMgmt me={me} />, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/templates"} component={hasFeature("TEMPLATES", TemplateList, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/analytics-config"} render={() => hasFeature("COMPANY_MANAGEMENT", <AnalyticsConfigEditor />, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/brand-settings/brand"} render={() => <StyleGuide me={me} organisation={organisation} />} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/brand-settings/sub-brands/:subBrandId"} render={() => hasFeature("BRAND_MANAGEMENT", <SubBrandPage me={me} organisation={organisation} />, me)} />
				<Route exact path={ROUTE_PATHS[PAGES.ADMIN] + "/brand-settings/sub-brands"} render={() => hasFeature("BRAND_MANAGEMENT", <SubBrandsList me={me} organisation={organisation} />, me)} />

			</Switch>
		</>
	);
}

export default AdminPage;
